module.exports = __webpack_public_path__ + "static/img/trainingDays.8a3e6d65.svg";